@if (creditBalance) {
  <button
    type="button"
    class="ai-balance-card"
    [class.ai-balance-card--low]="creditBalance.low_balance"
    [routerLink]="creditPackagesRoute">
    <span class="ai-balance-card__icon">
      <mat-icon>{{ creditBalance.low_balance ? 'error_outline' : 'auto_awesome' }}</mat-icon>
    </span>
    <span class="ai-balance-card__body">
      <span class="ai-balance-card__label">{{ 'AIBalance' | translate }}</span>
      <span class="ai-balance-card__num">{{ creditBalance.balance | number: '1.0-0' }}</span>
    </span>
    @if (creditBalance.low_balance) {
      <span class="ai-balance-card__cta">Buy more</span>
    }
  </button>
}
